import React from "react";
import T from "prop-types";
import {
  Detail,
  DetailTable,
  LocationFlag,
  Section
} from "MODULES/shared/components";
import { get } from "lodash";
import { VENDOR_TERMS } from "MODULES/companies/constants";
import { Link } from "react-router-dom";
import pojo from "LIB/pojos";
import { BUYING_STORE_ID } from "MODULES/PurchaseOrders/constants";
import { BUYER_ID, CO_BUYER_ID } from "MODULES/users/constants";
import {
  STORE_LOCATION_ID,
  STORE_OWNER_ID
} from "MODULES/inventories/constants";
import { CONSIGNOR_PERCENTAGE, PAYMENT_TERMS } from "APP_ROOT/constants";
import Form from "./EditConsignment/Form";

export function DetailsTable({ consignment }) {
  return (
    <Section
      title="Details"
      editable
      modal={{
        title: "Edit Consignment",
        content: close => (
          <Form
            initialValues={pojo(consignment).pick(
              BUYER_ID,
              CO_BUYER_ID,
              CONSIGNOR_PERCENTAGE,
              BUYING_STORE_ID,
              STORE_OWNER_ID,
              STORE_LOCATION_ID,
              PAYMENT_TERMS
            )}
            buyer={consignment.buyer}
            coBuyer={consignment.co_buyer}
            company={consignment.company}
            close={close}
          />
        )
      }}
    >
      <DetailTable>
        <Detail label="Buyer" value={get(consignment, "buyer.full_name")} />
        <Detail
          label="Co Buyer"
          value={get(consignment, "co_buyer.full_name")}
        />
        <Detail label="Company Code" value={get(consignment, "company.code")} />
        <Detail
          label="Company Name"
          value={
            <Link to={`/companies/${get(consignment, "company.uuid")}`}>
              {get(consignment, "company.name")}
            </Link>
          }
        />{" "}
        <Detail label="Company Name" value={get(consignment, "company.name")} />
        <Detail
          label="Company Phone"
          value={get(consignment, "company.phone")}
        />
        <Detail
          label="Payment Terms"
          value={get(VENDOR_TERMS, `${consignment.payment_terms}.label`)}
        />
        <Detail
          label="Store Owner"
          value={<LocationFlag location={consignment.store_owner_id} />}
        />
        <Detail
          label="Store Location"
          value={<LocationFlag location={consignment.store_location_id} />}
        />
      </DetailTable>
    </Section>
  );
}

DetailsTable.propTypes = {
  consignment: T.shape({
    part: T.shape({}),
    tag_date: T.string,
    serial_number: T.string,
    condition: T.string
  })
};



// WEBPACK FOOTER //
// ./app/modules/Consignments/Detail/DetailsTable.jsx